module.exports = __webpack_public_path__ + "static/media/beyondconflict-light.13a318f1.png";